import { render, staticRenderFns } from "./AGUSModalBlock.vue?vue&type=template&id=30956abc&scoped=true"
import script from "./AGUSModalBlock.vue?vue&type=script&lang=js"
export * from "./AGUSModalBlock.vue?vue&type=script&lang=js"
import style0 from "./AGUSModalBlock.vue?vue&type=style&index=0&id=30956abc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30956abc",
  null
  
)

export default component.exports